/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {translate} from '@ion/core/src/locale/locale';
import {ErrorSnackbar} from '@ion/dls/src/components/snackbars/ErrorSnackbar';
import {setDeviceError} from './state';
import {devicesError} from './state-selectors';

/**
 * Temporarily displays a snackbar with a message when smartSearch API fails.
 *
 * ```typescript
 *
 * import DeviceGridError from '@ion/applications/src/pages/devices/DeviceGridError';
 *
 * <DeviceGridError />
 *
 * ```
 */
const DeviceGridError = () => {
  const dispatch  = useDispatch();
  const showError = useSelector(devicesError);

  const onDismissErrorSnackbar = useCallback(() => {
    dispatch(setDeviceError());
  }, []);

  return (
    <ErrorSnackbar show={!!showError}
      message={translate('common:errorHandler.customMessage', {route: 'devices grid'})}
      onDismiss={onDismissErrorSnackbar} />
  );
};

export default DeviceGridError;
